import { render } from "./DocumentForm.vue?vue&type=template&id=c17de2ba&scoped=true&ts=true"
import script from "./DocumentForm.vue?vue&type=script&lang=ts"
export * from "./DocumentForm.vue?vue&type=script&lang=ts"

import "./DocumentForm.vue?vue&type=style&index=0&id=c17de2ba&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c17de2ba"]])

export default __exports__